import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { MarianomGeneral } from '../../marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'modal-alert-pass',
  templateUrl: './modal-alert-pass.component.html',
  styleUrls: ['./modal-alert-pass.component.scss']
})

export class ModalAlertPassComponent implements OnInit {

  constructor(private modal: ModalService, private genServ : EcommerceGenericoService) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-alert-pass');
  }

  get errorMessage() {
    return this.genServ.getErrorMessage();
  }

}
